import { UserDto } from "../../../../types/dto/UserDto";
import { User } from "../../../../types/User";

export const mapUserDtoToUser = (dto: UserDto): User => ({ ...dto });

const mapUsersDtoToUsers = (data: Array<UserDto>): Array<User> =>
  data.map(mapUserDtoToUser);

export default mapUsersDtoToUsers;
